export const SENTRY_FEATURE_FLAG = 'flow-enterprise-sentry-sample-rates'
export const DEFAULT_TRACES_SAMPLE_RATE = 0.2
export const DEFAULT_REPLAYS_SESSION_SAMPLE_RATE = 0.1
export const DEFAULT_REPLAYS_ON_ERROR_SAMPLE_RATE = 1.0
